import { render, staticRenderFns } from "./sectionM1.vue?vue&type=template&id=95784602&"
import script from "./sectionM1.vue?vue&type=script&lang=js&"
export * from "./sectionM1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports